// Iter 123 — Emergent Auth (Google). La langue UI voyage dans l'URL de retour (?lang=xx) :
// LanguageContext la ré-applique au retour, même dans un onglet neuf, avant l'onboarding.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const redirectToGoogleAuth = (lang) => {
  const redirectUrl = `${window.location.origin}/auth/google/callback?lang=${encodeURIComponent(lang || 'en')}`;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};
